import React from "react";
import "./RankingPodium.css";

// Order rendered: 2nd | 1st | 3rd
const PODIUM_CONFIG = [
  { index: 1, height: 72, bgColor: "#D1D5DB", crown: "🥈" },
  { index: 0, height: 98, bgColor: "#F7C500", crown: "🥇" },
  { index: 2, height: 54, bgColor: "#FDBA74", crown: "🥉" },
];

const PodiumColumn = ({ data, height, bgColor, crown }) => (
  <div className="bts-podium__col">
    <span className="bts-podium__crown">{crown}</span>

    <div className="bts-podium__avatar-circle">
      {data.pictureUrl ? (
        <img src={data.pictureUrl} alt={data.name} className="bts-podium__avatar-img" />
      ) : (
        <span style={{ fontSize: "24px" }}>{data.avatar || '👥'}</span>
      )}
    </div>

    <p className="bts-podium__team">ทีม{data.team}</p>
    <p className="bts-podium__name">{data.name}</p>

    <div
      className="bts-podium__block"
      style={{ height: `${height}px`, backgroundColor: bgColor }}
    >
      <span className="bts-podium__rank">#{data.rank}</span>
      <span className="bts-podium__pts">{data.points.toLocaleString()}</span>
    </div>
  </div>
);

const RankingPodium = ({ top3 }) => {
  return (
    <div className="bts-podium-card">
      <div className="bts-podium-card__top-bar" />
      <p className="bts-podium-card__subtitle">TOP 5 ประจำวัน</p>

      <div className="bts-podium__stage">
        {PODIUM_CONFIG.map(({ index, height, bgColor, crown }) => (
          <PodiumColumn
            key={top3[index].rank}
            data={top3[index]}
            height={height}
            bgColor={bgColor}
            crown={crown}
          />
        ))}
      </div>
    </div>
  );
};

export default RankingPodium;
